export default "__VITE_ASSET__aI8$AvBr__"